<template>
  <div class="eoev-chip-group">
    <slot />
  </div>
</template>

<script>
/**
 * Simple non-clickable chip group
 */
export default {
  name: "eo-chip-group"
};
</script>

<style lang="sass">
.eoev-chip-group .v-chip
  margin: 4px 8px 4px 0
</style>
